<template>
  <div class="allInOneContent">
    <div class="topBox">
      <div class="topTitle">V8</div>
      <!-- <div class="topText">STW32/43/49-V5</div> -->
      <img :src="AllInOne1" class="topImg" alt>
    </div>
    <div class="allInOneParent" style="margin-top:104px;">
      <div class="allInOneLeft">
        <div class="boxTitleBox">
          <div class="boxTitle">高配稳定版</div>
          <div class="boxTitleLine"></div>
        </div>
        <div class="boxP">支持基础播放，联屏及实时交互；高性能GPU,显示效果及流畅度最佳，独有外壳散热技术，提升运算性能。</div>
      </div>
      <div class="allInOneRight">
        <img :src="AllInOne2" alt>
      </div>
    </div>
    <!-- start -->
    <div class="allInOneParent marginTop100">
      <div class="allInOneLeft" style="width:50%;padding-left:0;">
        <img :src="AllInOne3" class="leftImg1" alt>
      </div>
      <div class="allInOneRight" style="width:40%;padding-left:10%;">
        <div class="boxTitleBox">
          <div class="boxTitle">支持软件</div>
          <div class="boxTitleLine"></div>
        </div>
        <div class="boxP">数拓全系列产品。</div>
      </div>
    </div>
    <!-- end -->
    <!-- start -->
    <div class="allInOneParent marginTop100">
      <div class="allInOneLeft">
        <div class="boxTitleBox">
          <div class="boxTitle">适合商家</div>
          <div class="boxTitleLine"></div>
        </div>
        <div class="boxP">
          大型连锁商家；对稳定性，显示效果，交互体验要求较高的商家；考虑未来业务迭代升级的商家。 
          
        </div>
      </div>
      <div class="allInOneRight">
        <img :src="AllInOne4" alt>
      </div>
    </div>
    <!-- end -->

    <div class="bottomImgBox">
      <img :src="AllInOne5" alt>
    </div>
  </div>
</template>
<script>
import AllInOne1 from "@/assets/images/vEight1.png";
import AllInOne2 from "@/assets/images/vEight2.png";
import AllInOne3 from "@/assets/images/vEight3.png";
import AllInOne4 from "@/assets/images/vEight4.png";
import AllInOne5 from "@/assets/images/vEight5.png";
import AllInOne6 from "@/assets/images/AllInOne6.png";
import AllInOne7 from "@/assets/images/AllInOne7.png";
import AllInOne8 from "@/assets/images/AllInOne8.png";
import AllInOne9 from "@/assets/images/AllInOne9.png";
export default {
  data() {
    return {
      AllInOne1: AllInOne1,
      AllInOne2: AllInOne2,
      AllInOne3: AllInOne3,
      AllInOne4: AllInOne4,
      AllInOne5: AllInOne5,
      AllInOne6: AllInOne6,
      AllInOne7: AllInOne7,
      AllInOne8: AllInOne8,
      AllInOne9: AllInOne9
    };
  }
};
</script>
<style scoped>
.allInOneContent {
  width: 70%;
  margin: auto;
  font-size: 0;
}
.topBox {
  text-align: center;
  margin-top: 114px;
}
.topTitle {
  font-size: 4rem;
  font-family: PingFangSC-Regular;
  font-weight: bold;
  color: rgba(88, 89, 89, 1);
}
.topText {
  margin-top: 20px;
  font-size: 3.2rem;
  font-family: PingFangSC-Regular;
  font-weight: bold;
  color: rgba(153, 153, 153, 1);
}
.topImg {
  width: 50%;
  max-width: 648px;
  margin-top: 20px;
}
/* start */
.boxTitle {
  font-size: 4rem;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  margin-top: 30%;
}
.boxTitleLine {
  width: 80px;
  height: 4px;
  margin-top: 20px;
  background: rgba(252, 200, 0, 1);
}
/* end */
.allInOneParent::after {
  content: "";
  display: block;
  clear: both;
}
.allInOneParent {
  margin-top: 20px;
}
.allInOneLeft {
  width: 40%;
  padding-left: 10%;
  float: left;
}
.boxTitleBox {
}
.allInOneRight {
  width: 50%;
  float: left;
}
.allInOneRight img {
  width: 100%;
}
.boxP {
  width: 70%;
  font-size: 2rem;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  margin-top: 40px;
  text-align: left;
  line-height: 40px;
}
.leftImg1 {
  width: 100%;

}
.marginTop100 {
  margin-top: 0px;
}
.bottomImgBox {
  margin-top: 73px;
  text-align: center;
}
.bottomImgBox img {
  width: 100%;
  max-width: 1200px;
}
.textCenter {
  text-align: center;
}
.marginAuto {
  margin: auto;
  margin-top: 20px;
}
.marginTop28 {
  margin-top: 28px;
}
.marginTop40 {
  margin-top: 40px;
}
.biaoTitle {
  text-align: center;
  margin-bottom: 20px;
  font-size: 4rem;
  font-family: PingFangSC-Semibold;
  font-weight: 600;
  color: rgba(51, 51, 51, 1);
}
</style>





// WEBPACK FOOTER //
// src/view/hardware/vEight.vue